(function() {
  var GAVisitor = function(visitorCookieName) {
    if (!visitorCookieName) {
      throw 'Cookie name is required'
    }

    this.id = this.cookies()[visitorCookieName];
  };

  GAVisitor.prototype.cookies = function() {
    return this.merge(this.parsedCookies());
  };

  GAVisitor.prototype.parsedCookies = function() {
    return this.rawCookies().map(function(cookieString) {
      return this.parse(cookieString);
    }.bind(this));
  };

  GAVisitor.prototype.rawCookies = function() {
    return this.cookiesString().split("; ");
  };

  GAVisitor.prototype.cookiesString = function() {
    return document.cookie;
  };

  GAVisitor.prototype.merge = function(cookies) {
    return cookies.reduce(function(memo, cookie) {
      memo[cookie.name] = cookie.value;
      return memo;
    }, {});
  };

  GAVisitor.prototype.parse = function(cookieString) {
    return {
      name: cookieString.slice(0, cookieString.indexOf("=")),
      value: cookieString.slice(cookieString.indexOf("=") + 1)
    };
  };

  GAVisitor.getTrackingPixel = function(baseUrl, callback, timeout) {
    // Default to the production URL
    baseUrl = baseUrl || "https://generalassemb.ly";

    // Default the timeout to 2 seconds
    timeout = timeout || 2000;

    var pixel = document.createElement("img");
    pixel.src = baseUrl + "/images/pixel-" + Date.now() + ".gif";
    pixel.id = "ga-visitor-id-pixel";
    pixel.style.display = "none";

    // Invoke callback once pixel has loaded, or after 2 seconds.
    if (typeof(callback) === "function") {
      if (typeof(Promise) === "undefined") {
        setTimeout(callback, timeout);
      } else {
        Promise.race([
          new Promise(function(resolve, reject) {
            pixel.onload = resolve;
          }),
          new Promise(function(resolve, reject) {
            setTimeout(resolve, timeout);
          })
        ]).then(callback);
      }
    }

    document.body.appendChild(pixel);
  };

  if (typeof(module) !== 'undefined') {
    module.exports = GAVisitor;
  }

  if (typeof(window) !== 'undefined') {
    window.GAVisitor = GAVisitor;
  }
})();
